import { Tooltip } from "antd";
import { LuMoon, LuSun } from "react-icons/lu";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { toggleTheme } from "store/themeSlice";

const ThemeSwitcher = () => {
  const dispatch = useDispatch();
  const theme = useSelector((state: RootState) => state.theme);

  return (
    <div className="Header-Icon" onClick={() => dispatch(toggleTheme())}>
      {theme === "light" ? (
        <Tooltip title="Dark tema">
          <LuMoon className="custom-icon" />
        </Tooltip>
      ) : (
        <Tooltip title="Light tema">
          <LuSun className="custom-icon" />
        </Tooltip>
      )}
    </div>
  );
};

export default ThemeSwitcher;
